/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserUpdateFeaturesAnyOf } from './userUpdateFeaturesAnyOf';

export type UserUpdateFeatures = UserUpdateFeaturesAnyOf | null;
